import React, { useState, useEffect } from 'react';
import haukeApiService from '../../services/haukeApi';
import '../../assets/css/profil-admin.css';

const UeberUns = ({ hofId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    loadData();
  }, [hofId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await haukeApiService.getDirekterzeugerDetails(hofId);
      setData(response.data);
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setData({ ...data, [field]: value });
    setHasChanges(true);
  };

  const showSuccessToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'success-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  };

  const handleSave = async () => {
    if (!hasChanges) return;

    try {
      setSaving(true);
      const updateData = {
        description: data.description
      };
      
      await haukeApiService.updateDirekterzeuger(hofId, updateData);
      setHasChanges(false);
      showSuccessToast('Beschreibung erfolgreich gespeichert!');
    } catch (err) {
      console.error('Error saving:', err);
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (hasChanges) {
      if (window.confirm('Änderungen verwerfen?')) {
        loadData();
        setHasChanges(false);
      }
    }
  };

  if (loading) return <div className="webling-loading">Daten werden geladen...</div>;
  if (error) return <div className="webling-error">{error}</div>;
  if (!data) return <div className="webling-error">Keine Daten verfügbar</div>;

  return (
    <div className="webling-container">
      <div className="webling-content">
        <div className="form-section">
          <h3>Beschreibung</h3>
          <table className="webling-form">
            <tbody>
              <tr className="form-row">
                <td className="form-label">Beschreibung</td>
                <td className="form-input">
                  <textarea
                    value={data.description || ''}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    disabled={saving}
                    rows={8}
                    placeholder="Beschreibung eingeben..."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>

      <div className="webling-footer">
        <button 
          onClick={handleSave}
          disabled={!hasChanges || saving}
          className="save-button"
        >
          {saving ? 'Speichern...' : 'Speichern'}
        </button>
        <button 
          onClick={handleCancel}
          disabled={saving}
          className="cancel-button"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default UeberUns; 